export const DOCUMENT_NAME = Object.freeze({ 
    MUEVETE_LIBRE: 'muevete-libre'
});


